import React from 'react';
import { getLessonTypeChipClass } from '@/components/Dashboard/lessonTypeChipClass';
import { NonAttendanceType } from '@/types/overview';

const BADGE_CLASS =
  'text-subhead-14 flex h-6 min-w-6 shrink-0 items-center justify-center rounded-xl px-2 text-foreground';

const excusedTypes: Partial<Record<string, NonAttendanceType>> = {
  [NonAttendanceType.Sick]: NonAttendanceType.Sick,
  Sickness: NonAttendanceType.Sick,
  [NonAttendanceType.Other]: NonAttendanceType.Other,
  Other: NonAttendanceType.Other,
};

interface Props {
  value: string;
  previousValue?: string;
  valueFullName?: string | null;
  lessonTypeId: string;
  nonAttendanceType: string | null;
  isNonAttendance?: boolean;
}

export const EvaluationValueBadge: React.FC<Props> = ({
  value,
  previousValue,
  valueFullName,
  lessonTypeId,
  nonAttendanceType,
  isNonAttendance = false,
}) => {
  const excusedType = nonAttendanceType
    ? excusedTypes[nonAttendanceType]
    : undefined;
  const label = previousValue ? `${previousValue} | ${value}` : value;
  const isNonAttendanceBadge = !!nonAttendanceType || isNonAttendance;
  const nonAttendanceColorClass = excusedType
    ? 'bg-on-primary-surface'
    : 'bg-red-soft';
  const colorClass = isNonAttendanceBadge
    ? nonAttendanceColorClass
    : getLessonTypeChipClass(lessonTypeId);

  const badge = (
    <span className="relative flex shrink-0">
      <span className={`${BADGE_CLASS} ${colorClass}`}>{label}</span>
      {!!excusedType && (
        <span className="text-caption-10 absolute -top-1.5 -right-1.5 flex size-4 items-center justify-center rounded-full bg-blue-soft font-semibold leading-none text-foreground">
          {excusedType}
        </span>
      )}
    </span>
  );

  if (!valueFullName) {
    return badge;
  }

  return (
    <span className="flex min-w-0 items-center gap-2 md:gap-3">
      {badge}
      <span
        className={`text-caption-12 min-w-0 truncate rounded-xl px-2 py-0.5 text-foreground ${colorClass}`}
      >
        {valueFullName}
      </span>
    </span>
  );
};
